import config from '@/config'
import VindiHttpClient from '@/api/http/vindi_client'

const httpVindi = new VindiHttpClient(config.vindiBaseUrl)

export default {
  async createPaymentProfile(card, customerId) {
    // Passing Static Payment Comapany Code, Method & Customer ID for Testing Purpose
    const response = await httpVindi.post(`/api/v1/public/payment_profiles`, {
      holder_name: card.holderName,
      card_expiration: `${card.expirationMonth}/${card.expirationYear}`,
      card_number: card.number,
      card_cvv: card.cvv,
      payment_method_code: 'credit_card',
      payment_company_code: 'mastercard',
      customer_id: customerId
    }, true)

    let body = null
    try { body = await response.json() } catch {}

    if (!response.ok) {
      return false
    }

    return body
  }
}
